// BACKEND API URL
//export const defaultURl = 'https://localhost:44325/v1/'
//export const defaultURl = 'https://localhost:7219/v1/'
//export const defaultURl = 'https://mycif.azurewebsites.net/api/'
export const defaultURl = 'https://mycif.cif.org.pt/api/v1/'
//export const defaultURl = 'http://mycif.cif.org.pt:82/api/v1/'